import { styled } from 'styled-system/jsx'

const PageRoot = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'linear-gradient(160deg, #F6F3FF 0%, #FFFFFF 65%)',
  },
})

const CardWrap = styled('div', {
  base: {
    width: '100%',
    maxWidth: '440px',
  },
})

const Content = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '14px',
    textAlign: 'center',
  },
})

const Title = styled('h1', {
  base: {
    fontSize: '24px',
    fontWeight: 700,
    color: '#1A1430',
  },
})

const Body = styled('p', {
  base: {
    fontSize: '15px',
    lineHeight: 1.5,
    color: '#5B5470',
  },
})

export { PageRoot, CardWrap, Content, Title, Body }
